import {ADD_QUALIFICATION, UPDATE_QUALIFICATION, FETCH_QUALIFICATIONS, LOADING_QUALIFICATION} from "../actions/types";
import _ from 'lodash';

export default function(state = {}, action) {

    switch (action.type) {
        case UPDATE_QUALIFICATION:
            let qualification = [];
            _.each(state.qualifications, (qual) => {
                if (action.data.search === qual.qual_id){
                    qual.display = action.data.display;
                }
                qualification.push(qual);
            })
            return {...state, qualifications: qualification};
        case LOADING_QUALIFICATION:
            return {...state, loading: action.data};
        case ADD_QUALIFICATION:
            return {...state};
        case FETCH_QUALIFICATIONS:
            let localQualCount = 1;
            const qualificationsWithIds = action.data.map((item) => {
                const newItem = { ...item, localQual: item.qualification_org === "south lanarkshire" };
                if (newItem.localQual && !newItem.qualification_id) {
                    newItem.qualification_id = `SLC${localQualCount++}`;
                }
                return newItem;
            });

            return {...state, loading: false, qualifications: _.filter(qualificationsWithIds, 'qualification'), loaded: true};
        default:
        return state;
      }
}